import { AllocationDefinitionDTO } from "../DTO/allocationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateAllocationDefinitionRequest extends BasicRequest{
   
    public allocationDefinition! : AllocationDefinitionDTO;
    
    constructor(){
        super();
    }
}